"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.paymentBillSalesChannel = void 0;
exports.paymentBillSalesChannel = { "WEB": { "name": "Website", "transactionCode": "" }, "AYO": { "name": "Ayo platform", "transactionCode": "" }, "OFF": { "name": "Offline", "transactionCode": "" } };
